module.exports = __webpack_public_path__ + "static/media/M121ws.9b9c7a1c.pdf";